// Imports
import { API } from 'aws-amplify';

// Keys
// const fetchErrorType = 'QUERY FETCH ERROR';
// const amplifyErrorType = 'QUERY AMPLIFY ERROR';

const FETCH = 'FETCH';
const AMPLIFY = 'AMPLIFY';

const GET = 'GET';
const POST = 'POST';
const DELETE = 'DELETE';
const PATCH = 'PATCH';
const PUT = 'PUT';

const meloAPI = 'meloappAPI';

// Variables
const currentFetchType = AMPLIFY;

// Objects
const JSON_HEADERS = { 'Content-Type': 'application/json' };
const APIS_URLS = { [meloAPI]: process.env.REACT_APP_MELOAPP_API_URL };
const amplifyMethod = {
  [POST]: async (resource, path, init) => API.post(resource, path, init),
  [GET]: async (resource, path, init) => API.get(resource, path, init),
  [PATCH]: async (resource, path, init) => API.patch(resource, path, init),
  [DELETE]: async (resource, path, init) => API.del(resource, path, init),
  [PUT]: async (resource, path, init) => API.put(resource, path, init)
};

// Methods
const fetchQuery = async (url, method, body) => {
  const request = { method: method };
  const hasBody = !!body;
  if (hasBody) {
    request.body = JSON.stringify(body);
    request.headers = JSON_HEADERS;
  }
  const fetchResponse = await fetch(url, request);
  return await fetchResponse.json();
};

const amplifyQuery = async (resource, path, method, body) => {
  const init = { body };
  const responseMethod = amplifyMethod[method];
  return await responseMethod(resource, path, init);
};

const formatPath = (entity, path) => {
  const pathPart = !!path ? `/${path}` : '';
  const formatedPath = `/${entity}${pathPart}`;
  return formatedPath;
};

// Exports
export const getQueryMethod = (resource, entity) => {
  return async (path, method = GET, body = null) => {
    const formatedPath = formatPath(entity, path);
    if (currentFetchType === FETCH) {
      const url = `${APIS_URLS[resource]}${formatedPath}`;
      return await fetchQuery(url, method, body);
    } else if (currentFetchType === AMPLIFY) {
      return await amplifyQuery(resource, formatedPath, method, body);
    }
  };
};

export const getURLParams = params => decodeURIComponent(new URLSearchParams(params).toString());

export const entities = {
  open: 'open',
  users: 'users',
  businesses: 'businesses',
  purchases: 'purchases',
  suppliers: 'suppliers',
  agreements: 'agreements',
  payroll: 'payroll',
  payments: 'payments',
  accountability: 'accountability',
  webhooks: 'webhooks',
  tests: 'tests',
  clients: 'clients',
  admins: 'admins',
  products: 'products',
  charges: 'charges',
  cybersource: 'cybersource'
};

export const resources = { meloAPI };

export const methods = { POST, GET, PATCH, DELETE, PUT };
